import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import Uploader from 'rsuite/lib/Uploader';
import Form from 'react-bootstrap/Form';
import {__} from 'js/tool/page/current';

const proofUploaderStyle = {
	lineHeight:      '100px',
	width:           '100%',
	boxShadow:       'inset 0 0 3px black',
	border:          '1px solid rgba(0, 0, 0, 0.125)',
	marginTop:       15,
	backgroundColor: '#efefef',
};

const hiddenStyle = {display: 'none'};

function RepresentativeProofUploader({
	goBack,
	setProofFile,
	validationError,
	setValidationErrors,
}) {
	const [fileList, setFileList] = useState([]);

	function previewFile(file, callback) {
		const reader = new FileReader();

		reader.onloadend = () => {
			callback(reader.result);
		};

		reader.readAsDataURL(file);
	}

	function uploadFile(file) {
		previewFile(file.blobFile, value => {
			setProofFile(value);
		});

		return false;
	}

	function setFileListSingle(files) {
		if (files && files.length > 0) {
			if (
				files[0] && files[0].blobFile && files[0].blobFile.type &&
				files[0].blobFile.type.includes('svg') ||
				!(files[0].blobFile.type.includes('image') || files[0].blobFile.type.includes('pdf'))
			) {
				setValidationErrors({proofFile: __('fb:only images and pdf')});

				return;
			}

			setFileList([files[files.length - 1]]);

			return;
		}

		setProofFile(null);
		setFileList([]);
	}

	return (
		<div style={{margin: '15px 0'}}>
			<div style={{fontSize: 14}}>
				<i className="fas mr-2 fa-exclamation-circle info-circle"/>
				{__('fb:upload a representative doc proof')}
				&nbsp;
				{
					goBack &&
					<Fragment>
						{'('}{__('fb:please click')}
						&nbsp;
						<a
							href="#"
							onClick={goBack}
						>
							{__('fb:here')}
						</a>
						&nbsp;{__('fb:is you are not')})
					</Fragment>
				}
			</div>

			<Uploader
				accept="pdf"
				draggable
				shouldUpload={uploadFile}
				onChange={setFileListSingle}
				fileList={fileList}
				className="proof-uploader"
			>
				<div style={fileList.length === 0 ? proofUploaderStyle : hiddenStyle}>
					{__('fb:click or drag to upload')}
				</div>
			</Uploader>

			<Form.Control.Feedback
				type="invalid"
				style={{display: 'block'}}
			>
				{validationError}
			</Form.Control.Feedback>
		</div>
	);
}

RepresentativeProofUploader.propTypes = {
	goBack:              PropTypes.func,
	setProofFile:        PropTypes.func.isRequired,
	setValidationErrors: PropTypes.func.isRequired,
	validationError:     PropTypes.string,
};

export default RepresentativeProofUploader;
